import React, { Suspense } from "react";

import EnvironmentProvider from "@/api/common/contexts/EnvironmentProvider"
import { DonationButtonProps } from "@/widgets/donation-button/DonationButton"

const DonationButton = React.lazy(() => import("@/widgets/donation-button/DonationButton"));

export const DonationButtonWrapper: React.FC<DonationButtonProps> = (props) => {
  return <EnvironmentProvider environment={import.meta.env.VITE_ENVIRONMENT}>
   <Suspense fallback={<div></div>}>
        <DonationButton {...props} />
      </Suspense>
  </EnvironmentProvider>
}